import app from './app';
import { USERPROFILE_SERVICE_URL } from './../../libs/constants';

//POST
const getUsers = (requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = {
            headers: {
                ...(requestData.lspId) && { "lspId": requestData.lspId },
                "HW-Fetch-Type": "getUsers"
            }
        };

        const response = await api.post(USERPROFILE_SERVICE_URL + 'users/list', requestData, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_USERS",
            payload: response.data
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

//GET 
const getUserDetails = userId => async (dispatch, getState, api) => {
    //dispatch(app.setLoading(true));

    await api.get(USERPROFILE_SERVICE_URL + "users/" + userId) // changed to support Akamai
        .then(response => {
            dispatch(app.setLoading(false));
            const payloadData = response.data.userId ? response.data : null;
            dispatch(setSelectedUserData(payloadData));
        })
        .catch(error => {
            dispatch(setSelectedUserData(null));
        });
};

const updateSpecificUser = (requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedUserDetail" } };
        const response = await api.post(USERPROFILE_SERVICE_URL + 'updateUserProfileData', requestData, headerConfig);

        dispatch(app.setLoading(false));

        if (response.data && response.data[0]) {
            dispatch({ type: "UPDATE_SPECIFIC_USER_DATA", data: response.data[0] });
        }
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const setUserDetailsCallComplete = isComplete => {
    return {
        type: 'SET_USER_DETAILS_CALL_COMPLETE',
        data: isComplete
    }
}

const selectedUserTeamsCallComplete = isComplete => {
    return {
        type: 'SET_SELECTED_USER_TEAMS_CALL_COMPLETE',
        data: isComplete
    }
}

const setSelectedUserData = data => {
    return {
        type: "SET_SELECTED_USER_DATA",
        payload: data
    }
}

const resetSelectedUserData = () => {
    return {
        type: 'RESET_SELECTED_USER_DATA'
    }
}

const setSearchFilter = (value) => {
    return {
        type: 'SET_SEARCH_FILTER',
        payload: value
    }
}

const usersActions = {
    getUsers: getUsers,
    getUserDetails: getUserDetails,
    setSelectedUserData: setSelectedUserData,
    setUserDetailsCallComplete: setUserDetailsCallComplete,
    selectedUserTeamsCallComplete: selectedUserTeamsCallComplete,
    resetSelectedUserData: resetSelectedUserData,
    updateSpecificUser: updateSpecificUser,
    setSearchFilter: setSearchFilter
}

export default usersActions;